const subscribeCustomerToNewsletter = async (formDataString: string) => {
	// Parameters `u` and `id` are grabbed from MailChimp's form creator, and is unique per audience
	return await fetch(`https://mobler.us14.list-manage.com/subscribe/post-json?u=9d6507ce12e46680cfb3e8d08&id=75c250b3ce&c=&${formDataString}`, {
		method: 'GET',
		mode: 'no-cors',
	})
}

export { subscribeCustomerToNewsletter }
